import { appConfig } from "@/appConfig";
import { Router } from "vue-router";
import { StatEventEnum } from "../sdk/ClientSdk";

/**
 * 埋点逻辑管理
 */
class StatManager {
    private pageReported: {[key: string]: boolean} = {};
    private page: string;

    constructor() {
        this.page = '';
        window.addEventListener('click', event => {
            const element = event.target as HTMLDivElement;
            if (element.getAttribute('stat-name') === '') return;
            const text = element.getAttribute('stat-name');
            if (!text) return;
            this.addClick(text);
        });
    }

    // 页面监控
    public setupPageEnterAndPageLeave(router: Router) {
        router.afterEach(async (to) => {
            setTimeout(() => {
                this.page = to.meta.pageName;
                !this.pageReported[this.page] && this.page && appConfig.sdk.event(StatEventEnum.view, {
                    page_name: to.meta.pageName,
                });
                this.pageReported[this.page] = true;
            }, 300);
        });
    }

    /**
     * 单独添加点击行为
     * @param targetName 
     */
    public addClick(targetName: string) {
        this.page && targetName && appConfig.sdk.event(StatEventEnum.click, {
            page_name: this.page,
            target_name: targetName,
        });
    }

    /**
     * 业务逻辑埋点
     * @param targetName 
     */
    public addStat(eventId: string, props:{[key: string]: string | number | null | undefined}) {
        this.page && appConfig.sdk.event(eventId as StatEventEnum, {
            page_name: this.page,
            ...props,
        });
    }
}

export const stat = new StatManager();